import { showNewMessage } from '@intercom/messenger-js-sdk';
import { externalLink } from '@synoptic/ui-kit/external-link.css.ts';
import { Hint } from '@synoptic/ui-kit/hint/hint.tsx';
import { InfoCircleIcon } from '@synoptic/ui-kit/icons/react/info-circle.tsx';
import {
  formInfoBlock,
  formInfoDescription,
  formInfoTitle,
} from '@/components/streams/stream-form/stream-form.css.ts';

export const PriceInfo = ({
  guidance,
}: {
  guidance?: {
    message: string;
    entityName: string;
  };
}) => {
  const handleGuidanceClick = () => {
    if (guidance) showNewMessage(guidance.message);
  };

  return (
    <div className={formInfoBlock}>
      <h3 className={formInfoTitle}>
        Pricing
        <Hint description="The price you set cannot be changed later, so choose carefully.">
          <InfoCircleIcon width={16} height={16} />
        </Hint>
      </h3>
      {guidance && (
        <p className={formInfoDescription}>
          You can personalize your price per month, however we recommend to
          follow our guidelines to reach better results with your{' '}
          {guidance.entityName}.{' '}
          <span className={externalLink} onClick={handleGuidanceClick}>
            Get Synoptic guidance on price.
          </span>
        </p>
      )}
    </div>
  );
};
